import { useState } from "react";

import axios from "axios";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";

export function OwnPasswordDialog({ open, onOpenChange, sessionId, API, userEmail }) {
  const [email, setEmail] = useState(userEmail || "");
  const [emailSaved, setEmailSaved] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [saving, setSaving] = useState(false);

  const resetForm = () => {
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setEmailSaved(false);
  };

  const handleSaveEmail = async () => {
    try {
      await axios.put(`${API}/user/email?session_id=${sessionId}`, { email: email.trim() });
      setEmailSaved(true);
      setTimeout(() => setEmailSaved(false), 2000);
    } catch (err) {
      console.error("Email save error:", err);
    }
  };

  const handleSave = async () => {
    if (newPassword !== confirmPassword) {
      
      return;
    }
    if (newPassword.length < 4) {
      
      return;
    }

    try {
      setSaving(true);
      await axios.put(`${API}/user/password?session_id=${sessionId}`, {
        current_password: currentPassword,
        new_password: newPassword,
      });
      
      resetForm();
      onOpenChange(false);
    } catch (err) {
      
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { onOpenChange(v); if (!v) resetForm(); else setEmail(userEmail || ""); }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold uppercase tracking-tight">
            Mein Profil
          </DialogTitle>
          <DialogDescription>
            Ändern Sie Ihre E-Mail-Adresse oder Ihr Passwort.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 pt-4">
          <div className="space-y-2">
            <Label className="uppercase tracking-[0.15em] text-xs font-semibold">
              E-Mail-Adresse
            </Label>
            <div className="flex gap-2">
              <Input
                data-testid="own-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="E-Mail-Adresse eingeben"
                className="input-focus flex-1"
              />
              <Button
                data-testid="save-own-email-button"
                size="sm"
                onClick={handleSaveEmail}
                className="px-3"
              >
                {emailSaved ? "Gespeichert!" : "Speichern"}
              </Button>
            </div>
          </div>

          <div className="border-t border-border my-2" />

          <div className="space-y-2">
            <Label className="uppercase tracking-[0.15em] text-xs font-semibold">
              Aktuelles Passwort
            </Label>
            <Input
              data-testid="current-password-input"
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Aktuelles Passwort"
              className="input-focus"
            />
          </div>

          <div className="space-y-2">
            <Label className="uppercase tracking-[0.15em] text-xs font-semibold">
              Neues Passwort
            </Label>
            <Input
              data-testid="own-new-password-input"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Neues Passwort (min. 4 Zeichen)"
              className="input-focus"
            />
          </div>

          <div className="space-y-2">
            <Label className="uppercase tracking-[0.15em] text-xs font-semibold">
              Neues Passwort bestätigen
            </Label>
            <Input
              data-testid="own-confirm-password-input"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Neues Passwort bestätigen"
              className="input-focus"
            />
          </div>

          <Button
            data-testid="save-own-password-button"
            onClick={handleSave}
            disabled={saving || !currentPassword || !newPassword || !confirmPassword}
            className="w-full"
          >
            {saving ? "Wird gespeichert..." : "Passwort ändern"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
